import styled from 'styled-components';
import SocialLinks from '../SocialLinks';


const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  //background: linear-gradient(100.26deg, rgba(0, 102, 255, 0.05) 42.33%, rgba(150, 0, 225, 0.05) 127.07%);
`;


const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
`;

const Nav = styled.nav`
  width: 100%;
  max-width: 900px;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  flex-wrap: nowrap;
  @media (max-width: 768px) {
    gap: 0.5rem;
    justify-content: center;
    text-align: center;
    font-size: 11px;
  }
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.2s ease-in-out;
  white-space: nowrap;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;


const Copyright = styled.p`
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.soft2};
  text-align: center;
`;

function Footer({ onContactClick, onLocationClick }) {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Logo>Urvansh Shah</Logo>
        <Nav>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
          <NavLink href="#achievement">Achievement</NavLink>
          <NavLink onClick={onContactClick} style={{ cursor: 'pointer' }}>Contact Me</NavLink>
        </Nav>
        <SocialLinks onLocationClick={onLocationClick} />
        <Copyright>
          © {new Date().getFullYear()} Urvansh Shah. All rights reserved. | Made with ❤️ and React
        </Copyright>
      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;